const React = require("react");
const T = React.PropTypes;

require("./SurveyList.less");

const auditTypes = require("~/config.js").AuditTypes;
const auditSearchDispatchers = require("~/events/auditSearch/auditSearchDispatchers.js");
const auditCreationDispatchers = require("~/events/auditCreation/auditCreationDispatchers.js");

const UserType = require("~/types/User.js").PropType;
const ErrorType = require("~/types/Error.js").PropType;
const MetaAuditType = require("~/types/MetaAudit.js").PropType;
const FacilityType = require("~/types/Facility.js").PropType;

const MajorMessage = require("../MajorMessage/MajorMessage.jsx");
const MajorError = require("../MajorError/MajorError.jsx");
const MajorLoading = require("../MajorLoading/MajorLoading.jsx");
const SurveyStatusList = require("../SurveyStatusList/SurveyStatusList.jsx");

const defaultSorter = (a, b) => {
    if (a < b) return -1;

    if (a > b) return 1;

    return 0;
};

const periodSorter = (a, b) => {
    const aPair = a.split(' ');
    const bPair = b.split(' ');

    if (aPair[1] < bPair[1]) return 1;
    if (aPair[1] > bPair[1]) return -1;
    if (aPair[0] < bPair[0]) return 1;
    if (aPair[0] > bPair[0]) return -1;

    return 0;
};

const SurveyList = React.createClass({
    propTypes: {
        User: UserType.isRequired,
        SurveySearchResults: T.shape({
            SelectedFacility: FacilityType,
            Data: T.arrayOf(MetaAuditType),
            IsLoading: T.bool.isRequired,
            Error: ErrorType
        }).isRequired,
        SurveyCreationStatus: T.shape({
            InProgress: T.bool,
            Error: ErrorType
        })
    },
    getInitialState() {
        return {
            SelectedFacility: this.props.SurveySearchResults.SelectedFacility,
            Filter: {
                Status: "",
                AuditPeriod: "",
                FriendlyTypeName: ""
            }
        };
    },
    componentWillReceiveProps(next) {
        if (this.props.SurveySearchResults.SelectedFacility
            !== next.SurveySearchResults.SelectedFacility) {
            this.setState({
                SelectedFacility: next.SurveySearchResults.SelectedFacility
            });
        }
    },
    render() {
        const header = this.GetHeader();
        const content = this.GetContents();

        return (<article className="cs-SurveyList">
            {header}
            {content}
        </article>);
    },
    GetHeader() {
        if (this.props.SurveyCreationStatus.InProgress
            || this.props.SurveyCreationStatus.Error) return null;

        window.User = Object.assign({}, this.props.User);

        const options = this.GetAvailableFacilities()
            .sort((f1, f2) => {
                if (f1.Number < f2.Number) return -1;
                if (f1.Number > f2.Number) return 1;

                return 0;
            })
            .map((f, i) => {
                return (<option key={i} value={f.Number}>
                    {f.Name}
                </option>)
            });

        const selectedValue =
            this.state.SelectedFacility
            ? this.state.SelectedFacility.Number
            : "";

        return (<header className="cs-SurveyList__header">
            <h3>Audit List</h3>
            <div className="form form-inline">
                <label>
                    Pick&nbsp;a&nbsp;facility
                </label>
                <select className="form-control cs-SurveyList__facility-picker"
                        onChange={this.FacilityChanged}
                        value={selectedValue}>
                    <option>- Please select -</option>{options}
                </select>
                <button className="btn btn-primary"
                        onClick={this.Search}
                        disabled={!selectedValue}>
                    <span className="glyphicon glyphicon-search cs-SurveyList__facility-pick-icon"></span>
                    Find Audits
                </button>
            </div>
        </header>);
    },
    GetAvailableFacilities() {
        return this.props.User.Divisions
            .reduce((agg, d) => agg.concat(d.Districts), [])
            .reduce((agg, d) => agg.concat(d.Facilities), []);
    },
    FacilityChanged(e) {
        const selectedFac = this.GetAvailableFacilities()
            .find(fac => fac.Number === e.target.value);

        this.setState({
            SelectedFacility: selectedFac
        });
    },
    Search() {
        if (this.state.SelectedFacility) {
            auditSearchDispatchers.FindAudits(this.state.SelectedFacility);
        }
    },
    GetContents() {
        if (this.props.SurveyCreationStatus.Error) {
            return (<MajorMessage>
                <h2 className="cs-SurveyList__MajorMessage-headline">
                    There was a problem creating the audit.
                </h2>
                <h3 className="cs-SurveyList__MajorMessage-headline">
                    First thing to do is try it again:
                    <button className="btn btn-primary cs-SurveyList__MajorMessage__button"
                            onClick={this.ClearCreationError}>
                        Click here
                    </button>
                </h3>
                <h3 className="cs-SurveyList__MajorMessage-headline">
                    If you continue to get errors, please contact Support Services.
                </h3>
                <MajorError Error={this.props.SurveyCreationStatus.Error} />
            </MajorMessage>);
        }

        if (this.props.SurveyCreationStatus.InProgress) {
            return (<MajorMessage>
                <h2 className="cs-SurveyList__MajorMessage-headline">
                    Creating a new audit
                </h2>
                <h3>
                    for {this.props.SurveySearchResults.SelectedFacility.Name}
                </h3>
            </MajorMessage>);
        }

        if (this.props.SurveySearchResults.Error) {
            return (<MajorMessage>
                <h2 className="cs-SurveyList__MajorMessage-headline">
                    There was a problem loading the survey list.
                </h2>
                <h3 className="cs-SurveyList__MajorMessage-headline">
                    First thing to do is try it again.
                </h3>
                <h3 className="cs-SurveyList__MajorMessage-headline">
                    If you continue to get errors, please contact Support Services.
                </h3>
                <MajorError Error={this.props.SurveySearchResults.Error } />
            </MajorMessage>);
        }

        if (this.props.SurveySearchResults.IsLoading) {
            return (<MajorLoading />);
        }

        if (this.props.SurveySearchResults.Data) {
            const filter = this.GetFilter();
                        
            const list = this.GetList();

            return (<div>
                {filter}
                {list}
            </div>);
        }
    },
    GetList() {
        const items = this.props.SurveySearchResults.Data
            .filter(this.FilterSurvey);
        
        if (items.length) {
            return (<SurveyStatusList Data={items} />);
        }

        return (<MajorMessage>
            <h3 className="cs-SurveyList__MajorMessage-headline">
                No audits for store
                &nbsp;
                {this.props.SurveySearchResults.SelectedFacility.Number}
                &nbsp;
                match the specified filter.
            </h3>
        </MajorMessage>); 
    },
    ClearCreationError() {
        auditCreationDispatchers.ClearError();
    },
    FilterSurvey(s) {
        if (this.state.Filter.Status
            && this.state.Filter.Status !== s.Status)
            return false;

        if (this.state.Filter.AuditPeriod
            && this.state.Filter.AuditPeriod !== s.AuditPeriod)
            return false;

        if (this.state.Filter.FriendlyTypeName
            && this.state.Filter.FriendlyTypeName !== s.FriendlyTypeName)
            return false;

        return true;
    },
    GetFilter() {
        const statusOptions = this.GetFilterOptions("Status");
        const periodOptions = this.GetFilterOptions("AuditPeriod", periodSorter);
        const typeOptions = Object.keys(auditTypes).map((k) => {
            const name = auditTypes[k].FriendlyName;
            
            return (<option key={name} value={name}>{name}</option>);
        });

        return (<div className="cs-SurveyList__filter">
            <h4>
                Filter results
            </h4>
            <div className="form form-inline">
                <label>Status</label>
                <select className="form-control cs-SurveyList__filter__select"
                        onChange={this.StatusFilterChanged}>
                    <option value="">Any</option>
                    {statusOptions}
                </select>
                <label>Period</label>
                <select className="form-control cs-SurveyList__filter__select"
                        onChange={this.PeriodFilterChanged}>
                    <option value="">Any</option>
                    {periodOptions}
                </select>
                <label>Type</label>
                <select className="form-control cs-SurveyList__filter__select"
                        onChange={this.TypeFilterChanged}>
                    <option value="">Any</option>
                    {typeOptions}
                </select>
            </div>
        </div>);
    },
    GetFilterOptions(fieldName, sorter) {
        sorter = sorter || defaultSorter;

        const result = this.props.SurveySearchResults.Data
            .reduce((agg, a) => {
                if (agg.indexOf(a[fieldName]) < 0) {
                    agg.push(a[fieldName]);
                }

                return agg;
            }, [])
            .sort(sorter)
            .map(s => (<option key={s} value={s }>{s}</option>));
            
        return result;
    },
    StatusFilterChanged(e) {
        const update = Object.assign({}, this.state.Filter, {
            Status: e.target.value
        });

        this.setState({ Filter: update });
    },
    PeriodFilterChanged(e) {
        const update = Object.assign({}, this.state.Filter, {
            AuditPeriod: e.target.value
        });

        this.setState({ Filter: update });
    },
    TypeFilterChanged(e) {
        const update = Object.assign({}, this.state.Filter, {
            FriendlyTypeName: e.target.value
        });

        this.setState({ Filter: update });
    }
});

module.exports = SurveyList;


// WEBPACK FOOTER //
// ./src/components/SurveyList/SurveyList.jsx